import axios from 'axios';
import { EMPRESA_STORAGE_KEY, MODO_GLOBAL } from '../utils/storageKeys';
import { getAccessToken, getRefreshToken, updateTokens } from '../utils/tokenStorage';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api/v1' });

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
  failedQueue = [];
};

api.interceptors.request.use((cfg) => {
  const token = getAccessToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;

  // super_admin não pertence a nenhuma empresa — os endpoints operacionais (estoque,
  // pedidos, lotes, cadastros...) exigem id_empresa explícito nesse caso, EXCETO em modo
  // Global (MODO_GLOBAL), onde omitir id_empresa é o que faz o backend listar todas as
  // empresas de uma vez. admin/operador ignoram esse parâmetro no backend (usam sempre a
  // própria empresa), então é seguro injetar aqui sem checar o perfil.
  const idEmpresaSelecionada = localStorage.getItem(EMPRESA_STORAGE_KEY);
  if (idEmpresaSelecionada && idEmpresaSelecionada !== MODO_GLOBAL && cfg.params?.id_empresa === undefined) {
    cfg.params = { ...cfg.params, id_empresa: idEmpresaSelecionada };
  }

  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry && !original.url?.includes('/auth/login')) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => failedQueue.push({ resolve, reject })).then((token) => {
          original.headers.Authorization = `Bearer ${token}`;
          return api(original);
        });
      }
      original._retry = true;
      isRefreshing = true;
      const refresh = getRefreshToken();
      if (!refresh) {
        window.dispatchEvent(new Event('auth:logout'));
        return Promise.reject(err);
      }
      try {
        const { data } = await axios.post(`${api.defaults.baseURL}/auth/refresh`, { refresh_token: refresh });
        updateTokens(data.access_token, data.refresh_token);
        processQueue(null, data.access_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        processQueue(e, null);
        window.dispatchEvent(new Event('auth:logout'));
        return Promise.reject(e);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(err);
  }
);

export default api;
